import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material/";
import SelectBoxPrimary from "../../components/SelectBoxPrimary";
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { getLicenceStandardsEvaluation, saveLicenceStandardsEvaluation } from "../../api/licence";
import { AvatarAndName } from "../../components/AvatarAndName";
import { baseUrl } from "../../api/config";
import { formatDateTime } from "../../common/StaticExports";
import { useSelector } from "react-redux";

const EvaluationContents = () => {
    const [evaluation, setEvaluation]:any = useState({});
    const [isEdited, setIsEdited] = useState(false);
    const selectedLicenceStandard = useSelector((state:any) =>  state.licence.selectedLicenceStandard);
    const currentClub = useSelector((state:any) => state.clubDetails);
    useEffect(() => {
        const fetchEvaluation = async () => {
            try {
                const response = await getLicenceStandardsEvaluation({standardId: selectedLicenceStandard?.id, clubId: currentClub.id});
                setEvaluation(response);
            } catch {

            }
        }
        (selectedLicenceStandard?.id !== undefined && selectedLicenceStandard?.id) &&
        fetchEvaluation();
    }, [])

    const manageEvaluationChange = (key:any, updatedValue:any) => {
        const tempData = { ...evaluation, [key]: updatedValue };
        setEvaluation(tempData);
        setIsEdited(true);
    }

    const saveEvaluation = () => {
        saveLicenceStandardsEvaluation({standardId: selectedLicenceStandard?.id, clubId: currentClub.id, data: evaluation})
        .then((res:any) => {
            setEvaluation(res);
        });
        setIsEdited(false);
    }

    return(
        <>
        <Box className={'sdCommentsWrapper'} onBlur={() => {isEdited && saveEvaluation()}}>
            <JoyCssVarsProvider>
                <Textarea 
                sx={{ borderRadius: '6px', mt: 0, width: '80%' }} 
                onChange={(e:any) => {manageEvaluationChange('comment', e.target.value)}} 
                placeholder='Add comment' 
                minRows={4} maxRows={4} 
                value={evaluation?.comment}/>
            </JoyCssVarsProvider>
            <Box className={'SDuserDetailsWrapper'}>
                {
                    evaluation?.comment !== null &&
                    evaluation?.comment !== '' &&
                    evaluation?.firstName != null &&
                    evaluation?.firstName != ''&&
                    <>
                    <AvatarAndName avatarName={evaluation?.firstName ? `${evaluation.firstName} ${evaluation.lastName}` : 'Undefined'}
                    avatarImage={evaluation.avatarPath ? `${baseUrl}/Content${evaluation.avatarPath}` : ''} />
                    <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(evaluation.updatedDate)}</Typography>
                    </>
                }
                <SelectBoxPrimary
                label={''} 
                report={'siteReview'} 
                options={[0, 1, 2, 3]} 
                isStatus={true} 
                manageChange={(e:any) => {manageEvaluationChange('status', e)}}
                selected={evaluation?.status || 0} />
            </Box>
        </Box>
        </>
    )
}

export default EvaluationContents;